import { useAuthStore } from "@kaplan-labs/up-auth-api-client";
import { useEffect, useRef } from "react";

import { ProfileType, useProfile, useTheme } from "@up/data";
import { Animation, LoadingError, LoadingModal, ProfileSelect } from "@up/ui";

export default function Profiles() {
  const auth = useAuthStore();
  const profile = useProfile();
  const theme = useTheme();

  /*
    Effects
    ░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
  */

  const initialized = useRef(false);
  useEffect(
    function autoSelectIfStudent() {
      const go = async function () {
        if (profile.isLoading || profile.didError || !profile.data) {
          return;
        }
        if (
          profile.data?.type === ProfileType.Student ||
          !("type" in profile.data)
        ) {
          initialized.current = true;
          // User is guaranteed to be authenticated
        }
      };

      if (initialized.current) {
        return;
      } else {
        go();
      }
    },
    [auth, initialized, profile],
  );

  /*
    User Interface
    ░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
  */

  if (profile.isLoading) {
    return <LoadingModal />;
  }

  if (profile.didError) {
    return (
      <LoadingError
        error="Sorry, we could not load your profile"
        errorCode={profile.errorCode}
      />
    );
  }

  if (profile.data) {
    return (
      <Animation type="splash-in">
        <ProfileSelect
          heading={
            <>
              <h2 className={theme.heading2Class}>Select a student</h2>
              <p className="mb-6">
                Who is the student you are enrolling today?
              </p>
            </>
          }
          contacts={profile.data.relatedStudents ?? []}
        />
      </Animation>
    );
  }

  return <div data-testid="checkout-profile-should-not-be-here" />;
}
